import { useQuery } from 'react-query'

import { CacheKeys } from '../helpers/cacheKeys'
import { getTruckV1 } from '../models/truck'

export function useTruckV1(id: string | undefined, options?: { enabled?: boolean }) {
  const { data } = useQuery(`${CacheKeys.TRUCK_V1}-${id}`, () => getTruckV1(id), {
    enabled: Boolean(id) && options?.enabled,
    refetchOnWindowFocus: false,
    retry: true,
    retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
  })

  return {
    truck: data?.truck,
  }
}
